import { api } from '../../DefaultService';
import {
  IIvsDeviceConfigUpdateParams,
  IIvsDeviceCreateProps,
  IIvsDeviceFilterProps,
  IIvsDeviceGetAllParams,
  IIvsDeviceProps,
  IIvsDeviceSimpleProps,
  IIvsDeviceUpdateParams,
} from './types';
import { IPaginationParams } from '../../types';

const ENDPOINT = 'v1/devices/cameras/ivs';

export const createIvsDeviceAsync = async (
  data: IIvsDeviceCreateProps,
): Promise<IIvsDeviceProps> => {
  return await api
    .post(ENDPOINT, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getIvsDeviceByIdAsync = async (
  id: number,
): Promise<IIvsDeviceProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllIvsDeviceByLicenseAsync = async (
  pagination: IPaginationParams,
  filter: IIvsDeviceFilterProps,
): Promise<IIvsDeviceSimpleProps[]> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`, {
      params: { ...pagination, ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllIvsDevicesByLicenseAsync = async ({
  pagination,
  filter,
}: IIvsDeviceGetAllParams): Promise<IIvsDeviceSimpleProps[]> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`, {
      params: { ...pagination, ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllIvsDeviceCountByLicenseAsync = async (
  filter: IIvsDeviceFilterProps,
): Promise<number> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense/count`, {
      params: { ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateIvsDeviceAsync = async ({
  id,
  data,
}: IIvsDeviceUpdateParams): Promise<IIvsDeviceProps> => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteIvsDeviceAsync = async (id: number): Promise<void> => {
  await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
export const updateConfigIvsDeviceAsync = async ({
  id,
  data,
}: IIvsDeviceConfigUpdateParams): Promise<void> => {
  await api.put(`${ENDPOINT}/${id}/config`, data).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};

export const getByIdsAsync = async (
  ids: number[],
): Promise<IIvsDeviceSimpleProps[]> => {
  const converted = ids.join(',');
  return await api
    .get(`${ENDPOINT}/getByIds`, {
      params: { ids: converted },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
